export default __webpack_public_path__ + "static/media/URINARY-FREQUENCY.3a85ad93.png";